import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccueilGestionComponent} from './accueil/accueil.component';
import {EditFormulaireComponent} from './formulaires-liste/edit-formulaire/edit-formulaire.component';
import {RenduFormulaireComponent} from './formulaires-liste/rendu-formulaire/rendu-formulaire.component';
import {ReponseFicheComponent} from './reponses/reponse-fiche/reponse-fiche.component';
import {ListHomeComponent} from './reponses/list-home/list-home.component';
import {ContainerResponseComponent} from './reponses/container-response/container-response.component';
import {roles} from '../common/enum/roles';
import {CheckGuardService} from '@Services/guards/check-guard.service';
import {AccueilReponsesComponent} from './demandes/accueil-reponses.component';
import {FormGuardService} from 'app/demat/common/guards/form-guard.service';
import {RequestersListFormComponent} from './formulaires-liste/requesters-list-form/requesters-list-form.component';
import {
  RequestersListFormEditComponent
} from './formulaires-liste/requesters-list-form/requesters-list-form-edit/requesters-list-form-edit.component';

const PARAMS = {'icon': 'no_accounts', 'message': 'Vous n\'êtes pas autorisé à accéder à cette page'};
const WITH_SUPERVISEUR = [roles.admin, roles.superviseur];
const WITH_GESTIONNAIRE = [roles.admin, roles.superviseur, roles.gestionnaire];

const routes: Routes = [
  {
    path: '',
    component: AccueilGestionComponent,
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    }
  },
  {
    path: 'creation-formulaire',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    },
    component: EditFormulaireComponent,
  },
  {
    path: 'edit/:id',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    },
    component: EditFormulaireComponent,
  },
  {
    path: 'procedure/:id',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    },
    component: RenduFormulaireComponent,
  },
  {
    path: 'responses/:id',
    component: ListHomeComponent,
    canActivate: [FormGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS,
      paramFormUuid: 'id'
    }
  },
  {
    path: 'responses/:id/:state',
    component: ListHomeComponent,
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS
    }
  },
  {
    path: 'response/:uuid',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS
    },
    component: ReponseFicheComponent,
  },
  {
    path: 'visualiser/:uuid',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS
    },
    component: ContainerResponseComponent,
  },
  {
    path: 'visualiser/avis/:uuid',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS,
      indexAvis: true
    },
    component: ContainerResponseComponent,
  },
  {
    path: 'demandes',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_GESTIONNAIRE,
      params: PARAMS
    },
    component: AccueilReponsesComponent,
  },
  // listes de sollicités
  {
    path: 'requesters-list/:uuid',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    },
    component: RequestersListFormComponent,
  },
  // édition d'une liste de sollicités pour gérer les membres
  {
    path: 'requesters-list/members/edit/:id/:uuid',
    canActivate: [CheckGuardService],
    data: {
      roles: WITH_SUPERVISEUR,
      params: PARAMS
    },
    component: RequestersListFormEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestionRoutingModule {

}
